export default __webpack_public_path__ + "static/media/ModoSobDemandaAvancado.287c3439.png";